/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainSettingsAdvertisementWeChatOptions } from './FxIdDomainSettingsAdvertisementWeChatOptions';
import {
    instanceOfFxIdDomainSettingsAdvertisementWeChatOptions,
    FxIdDomainSettingsAdvertisementWeChatOptionsFromJSON,
    FxIdDomainSettingsAdvertisementWeChatOptionsFromJSONTyped,
    FxIdDomainSettingsAdvertisementWeChatOptionsToJSON,
} from './FxIdDomainSettingsAdvertisementWeChatOptions';

/**
 * @type FxIdDomainSettingsAdvertisementOptionsWeChat
 * 
 * @export
 */
export type FxIdDomainSettingsAdvertisementOptionsWeChat = FxIdDomainSettingsAdvertisementWeChatOptions;

export function FxIdDomainSettingsAdvertisementOptionsWeChatFromJSON(json: any): FxIdDomainSettingsAdvertisementOptionsWeChat {
    return FxIdDomainSettingsAdvertisementOptionsWeChatFromJSONTyped(json, false);
}

export function FxIdDomainSettingsAdvertisementOptionsWeChatFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsAdvertisementOptionsWeChat {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsAdvertisementWeChatOptions(json)) {
        return FxIdDomainSettingsAdvertisementWeChatOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdDomainSettingsAdvertisementOptionsWeChatToJSON(json: any): any {
    return FxIdDomainSettingsAdvertisementOptionsWeChatToJSONTyped(json, false);
}

export function FxIdDomainSettingsAdvertisementOptionsWeChatToJSONTyped(value?: FxIdDomainSettingsAdvertisementOptionsWeChat | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainSettingsAdvertisementWeChatOptions(value)) {
        return FxIdDomainSettingsAdvertisementWeChatOptionsToJSON(value as FxIdDomainSettingsAdvertisementWeChatOptions);
    }

    return {};
}

